import React from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { FormLabel, Text, useColorModeValue } from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";

function MultiSelectDropdown({
    label,
    value,
    onChange,
    fetchData,
    className = "",
    labelClassName = "",
    multiSelect = true,
    required = false,
    error = false,
    placeholder = null
}) {
    const currentPage = 1;
    const brandStars = useColorModeValue("red.500", "red.400");
    const textColor = useColorModeValue("navy.700", "white");

    const loadOptions = async (searchValue, loadedOptions, { page }) => {
        const response = await fetchData(searchValue, page);

        if (response) {
            return {
                options: response.options,
                hasMore: response.hasMore,
                additional: {
                    page: page + 1,
                },
            };
        }
        return { options: [], hasMore: false, additional: null };
    };

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            whiteSpace: state.isFocused ? "pre-wrap" : "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        }),
        control: (provided) => ({
            ...provided,
            position: "relative",
        }),
    };

    const handleChange = (selectedOption) => {
        onChange(multiSelect ? selectedOption : selectedOption || null);
    };

    const clearSelection = (e) => {
        e.stopPropagation(); // Prevent dropdown from opening when clicking clear button
        onChange(null);
    };

    return (
        <div className={className} style={{ position: "relative" }}>
            <div className={labelClassName}>
                <FormLabel
                    ms="4px"
                    fontSize="l"
                    fontWeight="900"
                    color={textColor}
                    mb="10px"
                    mr="10px"
                    minWidth={"fit-content"}
                >
                    {label} {required && <Text as="span" color={brandStars}>*</Text>}
                </FormLabel>
            </div>
            <div className="w-100" style={{ position: "relative" }}>
                <AsyncPaginate
                    className={`${error && required ? "multiSelect_error" : ""}`}
                    value={value}
                    loadOptions={loadOptions}
                    isMulti={multiSelect}
                    closeMenuOnSelect={!multiSelect}
                    onChange={handleChange}
                    placeholder={`Select ${placeholder ? placeholder.toLowerCase() : label.toLowerCase()}...`}
                    noOptionsMessage={() => `No ${label.toLowerCase()} found`}
                    loadingMessage={() => `${label} Loading...`}
                    additional={{ page: currentPage }}
                    menuShouldScrollIntoView={false}
                    menuPortalTarget={document.querySelector("body")}
                    styles={customStyles}
                />

                {!multiSelect && value && (
                    <CloseIcon
                        onClick={clearSelection}
                        position="absolute"
                        right="40px"
                        top="50%"
                        transform="translateY(-50%)"
                        cursor="pointer"
                        boxSize={3}
                        color="gray.500"
                        _hover={{ color: "black" }}
                    />
                )}

                {error && required && (
                    <Text as="span" color={brandStars}>
                        Please select at least one {label.toLowerCase()}.
                    </Text>
                )}
            </div>
        </div>
    );
}

export default MultiSelectDropdown;
